import React, { useState, useEffect } from "react";

import axios from "axios";
import { validarData } from "../../../../../services/utils";
import { saveAs } from "file-saver";

import TableHeader from "../../../../../components/Table/Header";
import ModalListaPastas from "../../../../../components/ModalListaPastas";
import addMore from "../../../../../assets/icons/addMore.png";
import { trackPromise } from "react-promise-tracker";
import less from "../../../../../assets/icons/less.png";
import {
  obterPastasSelecionadas,
  obterPastasArquivosFilhos,
} from "../../../../../services/http/pastaService";
import {
  favoritarDocumento,
  removerFavorito,
} from "../../../../../services/http/favoritoService";
import {
  gerarLinkUnico,
  removerLink,
} from "../../../../../services/http/linkCompartilhado";

import IcTresPontos from "../../../../../assets/icons/iconeTresPontinhos.svg";
import {
  compartilharPasta,
  removerCompartilhamento,
} from "../../../../../services/http/pastaCompartilhada";

import { inativarPasta } from "../../../../../services/http/pastaService";

import {
  registrarDownloadArquivo,
  registrarDownloadPasta,
} from "../../../../../services/http/dashboardService";

import services from "../../../../../services";

import { Dropdown, List, Menu, message, Checkbox } from "antd";
import ModalInfo from "../../../../../components/ModalInfo";
import ModalPastaCopiar from "../../../../../components/ModalPastaCopiar";
import ModalMoverPasta from "../../../../../components/ModalMoverPasta";
import ModalListagemPastasArquivos from "../../../../../components/ModalListagemPastasArquivos";
import ModalGerarLinkUnico from "../../../../../components/ModalGerarLinkUnico";
import ModalEditarPasta from "../../../../../components/ModalEditarPasta";
import ModalRenomear from "../../../../../components/ModalRenomear";
import ModalCompartilharPasta from "../../../../../components/ModalCompartilharPasta";

import menuInfo from "../../../../../assets/iconsMenu/menuInfo.svg";
import menuRemoverLink from "../../../../../assets/icons/iconRemoverLink.svg";
import menuFavorito from "../../../../../assets/iconsMenu/menuFavorito.svg";
import menuEditar from "../../../../../assets/iconsMenu/menuEditar.svg";
import menuMover from "../../../../../assets/iconsMenu/menuMover.svg";
import menuRemover from "../../../../../assets/iconsMenu/menuRemover.svg";
import menuRenomear from "../../../../../assets/iconsMenu/menuRenomear.svg";
import menuCopiar from "../../../../../assets/iconsMenu/menuCopiar.svg";
import menuAbrir from "../../../../../assets/iconsMenu/menuAbrir.svg";
import menuCompartilhar from "../../../../../assets/iconsMenu/menuCompartilhar.svg";
import iconLinkSvg from "../../../../../assets/icons/iconLink.svg";
import iconDownloadSvg from "../../../../../assets/icons/iconDownload.svg";

import "./styles.scss";

let zip = require("jszip")();

const PermissoesPastas = ({
  setPastasPermissao,
  setIncluirSubPastas,
  incluirSubPastas,
  pastasComPermissao,
  setPastasRemovidas,
  setNovasPastasAdicionadasEdicao,
  naoConfiguravel,
}) => {
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [pastas, setPastas] = useState([]);
  const [tabelaColunas, setTabelaColunas] = useState([]);
  const [modalPastas, setModalPastas] = useState(false);
  const showModalPastas = () => {
    if (naoConfiguravel) {
      message.error(`Não é permitido alteração`);
      return;
    }
    setModalPastas(true);
  };
  const closeModalPastas = () => {
    setModalPastas(false);
  };
  const [idInfo, setIdInfo] = useState("");
  const [tipoInfo, setTipoInfo] = useState("");
  const [modalInfo, setModalInfo] = useState(false);
  const [modalCopiar, setModalCopiar] = useState(false);
  const [modalMover, setModalMover] = useState(false);
  const [linkUnicoGerado, setLinkUnicoGerado] = useState([{}]);
  const [modalLinkUnico, setModalLinkUnico] = useState(false);
  const [mostrarListagemLinks, setMostrarListagemLinks] = useState(false);
  const [idEditar, setIdEditar] = useState("");
  const [tipoEditar, setTipoEditar] = useState("");
  const [modalEditarPasta, setModalEditarPasta] = useState(false);
  const [idRenomear, setIdRenomear] = useState("");
  const [tipoRenomear, setTipoRenomear] = useState("");
  const [modalRenomear, setModalRenomear] = useState(false);
  const [infoPastaEditada, setInfoPastaEditada] = useState(null);
  const [modalAbrirPasta, setModalAbrirPasta] = useState(false);
  const [pastasArquivosFilhos, setPastaArquivosFilhos] = useState([]);
  const [idPastaDestino, setIdPastaDestino] = useState("");
  const [nomePastaDestino, setNomePastaDestino] = useState("");
  const [modalCompartilhar, setModalCompartilhar] = useState(false);
  const [pastaACompartilhar, setPastaACompartilhar] = useState(null);
  const [arquivoVisualizar, setArquivoVisualizar] = useState(null);
  const [pastaPaiDowload, setPastaPaiDownload] = useState(null);
  const [pastasDownload, setPastasDownload] = useState([]);
  const [arquivosDownload, setArquivosDownload] = useState([]);
  const [finalizarDownload, setFinalizarDownload] = useState(false);
  const [itemSelecionadoCopiarMover, setItemSelecionadoCopiarMover] =
    useState(null);

  const closeEditarPasta = () => {
    setModalEditarPasta(false);
  };
  const closeModalPasta = () => {
    setModalAbrirPasta(false);
  };
  const showModalRenomear = () => {
    setModalRenomear(true);
  };
  const closeModalRenomear = () => {
    setModalRenomear(false);
  };
  const closeModalCopiar = () => {
    setModalCopiar(false);
  };
  const closeModalMover = () => {
    setModalMover(false);
  };
  const showModalAbrirPasta = () => {
    setModalAbrirPasta(true);
  };
  const showEditarPasta = () => {
    setModalEditarPasta(true);
  };
  const showModalInfo = () => {
    setModalInfo(true);
  };

  const closeModalInfo = () => {
    setModalInfo(false);
  };
  const showModalLinkUnico = () => {
    setModalLinkUnico(true);
  };

  const showModalCompartilhar = (pasta) => {
    if (pasta) {
      setPastaACompartilhar(pasta);
      setModalCompartilhar(true);
    }
  };
  const closeModalCompartilhar = () => {
    setModalCompartilhar(false);
  };

  const removerPastas = () => {
    if (naoConfiguravel) {
      message.error(`Não é permitido alteração`);
      return;
    }
    var pastasRemovidas = pastas.filter((x) => x.checked);

    setPastasRemovidas(pastasRemovidas);

    pastasRemovidas.forEach((usuario) => {
      var index = pastas.findIndex((x) => x.id === usuario.id);
      if (index != -1) {
        pastas.splice(index, 1);
        setPastas(pastas);
      }
      setPastasPermissao([]);
    });
  };

  const removerItem = (id, tipo) => {
    if (tipo == "pasta") {
      trackPromise(
        inativarPasta(id, IdUser)
          .then((res) => {
            if (!res.fail) {
              message.success("Pasta removida com sucesso");
              let pastaIndex = pastas.findIndex((x) => x.id == id);

              if (pastaIndex != -1) {
                pastas.splice(pastaIndex, 1);
                setPastas(pastas);
                setPastasPermissao([]);
              }
            } else {
              if (res.errors[0].menssagem != undefined) {
                message.warning(res.errors[0].menssagem);
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const showEditar = (id, tipo) => {
    setIdEditar(id);
    setTipoEditar(tipo);

    showEditarPasta();
  };

  const closeModalLinkUnico = (dataValidade, senha, item) => {
    setModalLinkUnico(false);
  };

  const buscarPastasArquivosFilhos = (idPasta) => {
    trackPromise(
      obterPastasArquivosFilhos(idPasta, 10, 1)
        .then((res) => {
          if (!res.fail && res.data) {
            setPastaArquivosFilhos(res.data);
            showModalAbrirPasta();
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverLink = (idDocumento) => {
    trackPromise(
      removerLink(idDocumento)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleGerarLinkUnico = (item) => {
    const data = {
      idUsuario: IdUser,
      idDocumento: item.id,
      tipoDocumento: item.tipo,
      dataValidade: null,
      senha: null,
    };

    trackPromise(
      gerarLinkUnico(data)
        .then((res) => {
          if (!res.fail && res.data) {
            let array = [];
            array.push(res.data);

            setLinkUnicoGerado(array);

            setTimeout(() => {
              showModalLinkUnico();
            }, 100);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const favoritar = (idDocumento, tipo) => {
    let tipoDocumento = tipo.toLocaleLowerCase() == "arquivo" ? 1 : 0;

    let data = {
      idDocumento: idDocumento,
      idUsuario: IdUser,
      tipoDocumento: tipoDocumento,
    };

    trackPromise(
      favoritarDocumento(data)
        .then((res) => {
          if (!res.fail) {
            message.success(
              `${
                tipoDocumento == 0 ? "Pasta incluída" : "Arquivo incluído"
              } aos favoritos com sucesso.`
            );
            let pasta = pastas.find((x) => x.id == idDocumento);
            let pastaIndex = pastas.findIndex((x) => x.id == idDocumento);

            pasta.ehFavorito = true;

            pastas[pastaIndex] = pasta;

            setPastas(pastas);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverFavorito = (idDocumento) => {
    trackPromise(
      removerFavorito(idDocumento)
        .then((res) => {
          if (!res.fail) {
            message.success(`Pasta removida com de favoritos`);
            let pasta = pastas.find((x) => x.id == idDocumento);
            let pastaIndex = pastas.findIndex((x) => x.id == idDocumento);

            pasta.ehFavorito = false;

            pastas[pastaIndex] = pasta;

            setPastas(pastas);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const showInfo = (id, tipo) => {
    setIdInfo(id);
    setTipoInfo(tipo);
    showModalInfo();
  };

  const showRenomear = (id, tipo) => {
    setIdRenomear(id);
    setTipoRenomear(tipo);
    setTimeout(() => {
      showModalRenomear();
    }, 100);
  };

  const showCopiar = (id, tipo, item) => {
    setItemSelecionadoCopiarMover(item);
    setModalCopiar(true);
  };

  const showMover = (id, tipo, item) => {
    setItemSelecionadoCopiarMover(item);
    setModalMover(true);
  };

  const pesquisarPorNome = (value, page) => {};
  const onLoadData = (value, page) => {};

  const handleCompartilhar = (pasta, usuarios) => {
    let arrayUsuarios = [];

    Array(usuarios).forEach((item) => {
      arrayUsuarios.push(item.id);
    });

    let data = {
      idUsuarioDonoCompartilhamento: IdUser,
      idPasta: pasta.id,
      idUsuariosAcesso: usuarios.map((item) => {
        return item.id;
      }),
    };

    trackPromise(
      compartilharPasta(data)
        .then((res) => {
          if (!res.fail) {
            message.success("Pasta compartilhada com sucesso");
          }
          closeModalCompartilhar();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleRemoverCompartilhar = (pasta) => {
    trackPromise(
      removerCompartilhamento(IdUser, pasta.id)
        .then((res) => {
          if (!res.fail) {
            message.success("Compartilhamento removido com sucesso");
            closeModalCompartilhar();
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const finalizarDownloadPasta = async () => {
    if (pastaPaiDowload != null) {
      arquivosDownload.forEach((arq) => {
        if (arq.idParent == pastaPaiDowload.id) {
          zip.file(arq.nome, arq.baixado, { base64: true });
        }
      });

      pastasDownload.forEach((pasta) => {
        let folder = zip.folder(pasta.nome);

        arquivosDownload.forEach((arq, index) => {
          if (arq.idParent == pasta.id) {
            folder.file(arq.nome, arq.baixado, { base64: true });
          }
        });
      });

      let content = await zip.generateAsync({ type: "blob" });
      await registrarDownloadPasta(pastaPaiDowload.id);
      saveAs(content, pastaPaiDowload.nome);

      setArquivoVisualizar([]);
      setPastaPaiDownload(null);
      setPastaPaiDownload([]);
    }
  };

  const downloadFile = async (item) => {
    if (item) {
      if (item.tipo == 0) {
        setPastaPaiDownload(item);
        await downloadBuscarItensFilhos(item.id);

        finalizarDownloadPasta();
      } else {
        const link = document.createElement("a");
        link.href = item.urlArquivo;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    }
  };

  const downloadBuscarItensFilhos = async (idPastaPai) => {
    setFinalizarDownload(false);

    const res = await obterPastasArquivosFilhos(idPastaPai, 1000, 1);
    if (!res.fail && res.data) {
      for (const itemLista of res.data.lista) {
        if (itemLista.tipo == 0) {
          montarPastasDownload(itemLista);
          await downloadBuscarItensFilhos(itemLista.id);
        } else {
          if (itemLista.urlArquivo) {
            const arquivoBaixado = await axios
              .create()
              .get(itemLista.urlArquivo, {
                responseType: "arraybuffer",
              });

            let arquivoToBase64;

            arquivoToBase64 = Buffer.from(
              arquivoBaixado.data,
              "binary"
            ).toString("base64");

            let arquivo = {
              id: itemLista.id,
              idParent: itemLista.idParent,
              url: itemLista.urlArquivo,
              extensao: itemLista.extensao,
              nome: itemLista.nome,
              nomeOriginal: itemLista.nomeOriginal,
              path: itemLista.path,
              tipoMidia: itemLista.tipoMidia,
              baixado: arquivoToBase64,
            };

            montarArquivosDownload(arquivo);
          }
        }
      }
    } else {
      res.catch((error) => {
        console.error(error);
      });
    }

    setFinalizarDownload(true);
  };

  const montarPastasDownload = (item) => {
    setPastasDownload((prevent) => [...prevent, item]);
  };

  const montarArquivosDownload = (item) => {
    registrarDownload(item.id);
    setArquivosDownload((prevent) => [...prevent, item]);
  };

  const registrarDownload = (idArquivo) => {
    trackPromise(
      registrarDownloadArquivo(idArquivo)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const showMenu = (id, tipo, item) => {
    return (
      <div className="menu">
        <Menu>
          {tipo == "pasta" && (
            <>
              <Menu.Item
                key="1"
                onClick={() => buscarPastasArquivosFilhos(id)}
                icon={<img src={menuAbrir} />}
              >
                Abrir
              </Menu.Item>
              <hr className="linha-menu" />
            </>
          )}
          <Menu.Item
            key="2"
            onClick={() => showInfo(id, tipo)}
            icon={<img src={menuInfo} />}
          >
            Info
          </Menu.Item>
          {item.ehFavorito ? (
            <Menu.Item
              key="3"
              onClick={() => handleRemoverFavorito(id)}
              icon={<img src={menuFavorito} />}
            >
              Remover favorito
            </Menu.Item>
          ) : (
            <Menu.Item
              key="3"
              onClick={() => favoritar(id, tipo)}
              icon={<img src={menuFavorito} />}
            >
              Favorito
            </Menu.Item>
          )}
          <hr className="linha-menu" />
          {
            <Menu.Item
              key="4"
              onClick={() => downloadFile(item)}
              icon={<img src={iconDownloadSvg} />}
            >
              Fazer download...
            </Menu.Item>
          }

          {mostrarListagemLinks && (
            <Menu.Item
              key="5"
              onClick={() => {
                handleGerarLinkUnico(item);
              }}
              icon={<img src={iconLinkSvg} />}
            >
              Gerenciar link
            </Menu.Item>
          )}
          {mostrarListagemLinks == false &&
            !validarData(item.dataVencimento) && (
              <Menu.Item
                key="5"
                onClick={() => {
                  handleGerarLinkUnico(item);
                }}
                icon={<img src={iconLinkSvg} />}
              >
                Obter link
              </Menu.Item>
            )}
          {mostrarListagemLinks && (
            <Menu.Item
              key="6"
              onClick={() => {
                handleRemoverLink(item.id);
              }}
              icon={<img src={menuRemoverLink} />}
            >
              Remover link
            </Menu.Item>
          )}
          {
            <Menu.Item
              key="7"
              icon={<img src={menuCompartilhar} />}
              onClick={() => showModalCompartilhar(item)}
            >
              Compartilhar
            </Menu.Item>
          }
          {IsAdmin.toLocaleLowerCase() == "true" && (
            <>
              <hr className="linha-menu" />
              <Menu.Item
                key="8"
                onClick={() => showEditar(id, tipo)}
                icon={<img src={menuEditar} />}
              >
                Editar
              </Menu.Item>
              <Menu.Item
                key="9"
                onClick={() => showRenomear(id, tipo)}
                icon={<img src={menuRenomear} />}
              >
                Renomear
              </Menu.Item>
              <Menu.Item
                key="10"
                onClick={() => showMover(id, tipo, item)}
                icon={<img src={menuMover} />}
              >
                Mover
              </Menu.Item>
              <Menu.Item
                key="11"
                onClick={() => showCopiar(id, tipo, item)}
                icon={<img src={menuCopiar} />}
              >
                Copiar
              </Menu.Item>
              <hr className="linha-menu" />
              <Menu.Item
                key="12"
                onClick={() => removerItem(id, tipo)}
                icon={<img src={menuRemover} />}
              >
                Remover
              </Menu.Item>
            </>
          )}
        </Menu>
      </div>
    );
  };

  const atribuirLista = (pastas) => {
    let idsPastas = [];

    pastas?.forEach((pasta) => {
      idsPastas.push(pasta.id);
    });

    listasPastasSelecionadasPorIds(idsPastas);
  };

  const obterIdPastasNaoRepetidos = (idsPastas) => {
    pastas?.forEach((x) => {
      let index = idsPastas.findIndex((y) => y == x.id);
      if (index != -1) {
        idsPastas.splice(index, 1);
      }
    });
  };

  const checarStateIterable = (state, data) => {
    if (state?.length > 0) {
      return [...state, ...data];
    } else {
      return [...data];
    }
  };

  const listasPastasSelecionadasPorIds = (idsPastas) => {
    obterIdPastasNaoRepetidos(idsPastas);
    setNovasPastasAdicionadasEdicao((state) => [...state, ...idsPastas]);
    trackPromise(
      obterPastasSelecionadas(IdUser, idsPastas)
        .then((res) => {
          if (!res.fail && res.data) {
            setPastas((state) => checarStateIterable(state, res.data));
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const marcarRemovertodos = (checked) => {
    pastas?.forEach((element) => {
      element.checked = checked;
    });

    if (pastas?.length > 0) {
      setPastas([...pastas]);
    }
  };

  const adicionarOuRemoverPasta = (value, checked) => {
    var usuario = pastas.find((x) => x.id === value.id);
    usuario.checked = checked;
    var index = pastas.findIndex((x) => x.id === value.id);
    pastas[index] = usuario;

    setPastas([...pastas]);
  };

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  useEffect(() => {
    if (infoPastaEditada != null) {
      let pasta = pastas.find((x) => x.id == infoPastaEditada?.idPasta);
      let pastaIndex = pastas.findIndex(
        (x) => x.id == infoPastaEditada?.idPasta
      );

      pasta.nome = infoPastaEditada.nomePasta;

      pastas[pastaIndex] = pasta;

      setPastas(pastas);
    }
  }, [infoPastaEditada]);

  useEffect(() => {
    if (pastasComPermissao?.length > 0) {
      setPastas(pastasComPermissao);
    }
  }, [pastasComPermissao, naoConfiguravel]);

  useEffect(() => {
    setTabelaColunas([
      <Checkbox
        onClick={(event) => marcarRemovertodos(event.target.checked)}
        type="checkbox"
      />,
      "Nome",
      "Tamanho",
      "Tipo",
    ]);
  }, [pastas]);

  useEffect(() => {
    setPastasPermissao(pastas);
  }, [pastas]);

  useEffect(() => {
    if (finalizarDownload) {
      finalizarDownloadPasta();
    }
  }, [finalizarDownload]);

  return (
    <div className="mt-5">
      <div className="row" style={{ borderBottom: "1px solid #898989" }}>
        <div
          style={{ padding: "0px" }}
          className="col-md-7 col-sm-7 col-xl-7 mb-3"
        >
          <span className="titulosPermissoesNotificacoes">
            Pastas com esta permissão
          </span>
        </div>

        <div className="col-md-5 col-sm-5 col-xl-5">
          <span onClick={() => showModalPastas()} className="add-pasta mr-3">
            <img src={addMore}></img> Adicionar pasta
          </span>
          <span onClick={() => removerPastas()} className="pasta-excluir">
            <img src={less}></img> Excluir pasta
          </span>
        </div>
      </div>

      <div
        className="row"
        style={{
          height: `${pastas?.length > 7 ? "300px" : ""}`,
          overflow: `${pastas?.length > 7 ? "auto" : ""}`,
        }}
      >
        <table className="table table-borderless col-lg-12 mt-3">
          <TableHeader columns={tabelaColunas} />
          <tbody>
            {pastas?.length > 0 &&
              pastas?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span>
                      <Checkbox
                        checked={item.checked}
                        onClick={(event) =>
                          adicionarOuRemoverPasta(item, event.target.checked)
                        }
                        type="checkbox"
                      />
                    </span>
                  </td>
                  <td>
                    <span className="coluna-nome">
                      <span>{item.nome}</span>
                    </span>
                  </td>
                  <td>
                    <span style={{ marginLeft: "25px" }}>-</span>{" "}
                  </td>
                  <td> Pasta </td>
                  {item.tipo != null && (
                    <td className="text-right">
                      <List.Item className="list-item">
                        <Dropdown.Button
                          trigger={["click"]}
                          className="button-list"
                          overlay={() =>
                            showMenu(
                              item.id,
                              item.tipo == 0 ? "pasta" : "arquivo",
                              item
                            )
                          }
                          placement="bottomLeft"
                          icon={<img src={IcTresPontos} alt="Ícone" />}
                        ></Dropdown.Button>
                      </List.Item>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {modalPastas === true && (
        <ModalListaPastas
          closeModal={closeModalPastas}
          incluirSubPastas={incluirSubPastas}
          setIncluirSubPastas={setIncluirSubPastas}
          pastas={pastas}
          setPastas={atribuirLista}
          openModal={modalPastas}
        />
      )}

      {modalInfo && (
        <ModalInfo
          id={idInfo}
          tipo={tipoInfo}
          closeModal={closeModalInfo}
          openModal={modalInfo}
        />
      )}

      {modalLinkUnico && (
        <ModalGerarLinkUnico
          linkGerado={linkUnicoGerado}
          closeModal={closeModalLinkUnico}
          openModal={modalLinkUnico}
        />
      )}
      <ModalRenomear
        id={idRenomear}
        tipo={tipoRenomear}
        closeModal={closeModalRenomear}
        openModal={modalRenomear}
        buscar={pesquisarPorNome}
        onLoadData={onLoadData}
        setInfoPastaEditada={setInfoPastaEditada}
      />

      {modalEditarPasta && (
        <ModalEditarPasta
          id={idEditar}
          tipo={tipoEditar}
          closeModal={closeEditarPasta}
          openModal={modalEditarPasta}
          buscar={pesquisarPorNome}
          incluirSubPastas={incluirSubPastas}
          setIncluirSubPastas={setIncluirSubPastas}
          IdUser={IdUser}
          onLoadData={onLoadData}
          setInfoPastaEditada={setInfoPastaEditada}
        />
      )}

      {modalAbrirPasta && (
        <ModalListagemPastasArquivos
          openModal={modalAbrirPasta}
          closeModal={closeModalPasta}
          pastasArquivosFilhos={pastasArquivosFilhos}
          showCloseBtn={false}
        />
      )}

      {modalCopiar && itemSelecionadoCopiarMover && (
        <ModalPastaCopiar
          openModal={modalCopiar}
          closeModal={closeModalCopiar}
          itemSelecionadoCopiarMover={itemSelecionadoCopiarMover}
        />
      )}

      {modalMover && itemSelecionadoCopiarMover && (
        <ModalMoverPasta
          openModal={modalMover}
          closeModal={closeModalMover}
          itemSelecionadoCopiarMover={itemSelecionadoCopiarMover}
        />
      )}
      {modalCompartilhar && pastaACompartilhar && (
        <ModalCompartilharPasta
          openModal={modalCompartilhar}
          closeModal={closeModalCompartilhar}
          handleCompartilhar={handleCompartilhar}
          handleRemoverCompartilhar={handleRemoverCompartilhar}
          pasta={pastaACompartilhar}
        />
      )}
    </div>
  );
};

export default PermissoesPastas;
